"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _Constants = require("FileManagerCore/Constants");

var _Files = require("FileManagerCore/actions/Files");

var _file = require("FileManagerCore/utils/file");

var _logging = require("FileManagerCore/utils/logging");

var _ImageEditor = _interopRequireDefault(require("FileManagerCore/components/ImageEditor"));

var _ScopedFeatureTooltip = _interopRequireDefault(require("FileManagerCore/components/permissions/ScopedFeatureTooltip"));

var _EditAndCreateImage = require("FileManagerCore/selectors/EditAndCreateImage");

var _Permissions = require("FileManagerCore/selectors/Permissions");

var _Configuration = require("../selectors/Configuration");

var _FileAccess = require("../enums/FileAccess");

var EditButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EditButton, _Component);

  function EditButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EditButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EditButton).call(this, props));
    _this.mounted = false;
    _this.state = {
      showImageEditor: false
    };
    _this.handleSave = _this.handleSave.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCropSave = _this.handleCropSave.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleResizeSave = _this.handleResizeSave.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(EditButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _logging.logNewRelicPageAction)('mount', {
        componentName: this.constructor.displayName,
        uploadedFileAccess: this.props.uploadedFileAccess
      });
    }
  }, {
    key: "handleSave",
    value: function handleSave(file, newFile, newUrl) {
      var _this$props = this.props,
          onSave = _this$props.onSave,
          onSaveComplete = _this$props.onSaveComplete,
          uploadedFileAccess = _this$props.uploadedFileAccess;
      onSave(file, newFile, newUrl, uploadedFileAccess).then(function (savedFile) {
        if (onSaveComplete) {
          onSaveComplete(savedFile.get('url'), savedFile);
        }
      });
    }
  }, {
    key: "handleCropSave",
    value: function handleCropSave(file, fileName, folderId) {
      var _this$props2 = this.props,
          dispatchUploadEditedImage = _this$props2.dispatchUploadEditedImage,
          onSaveComplete = _this$props2.onSaveComplete,
          uploadedFileAccess = _this$props2.uploadedFileAccess;
      dispatchUploadEditedImage(file, fileName, folderId, uploadedFileAccess, onSaveComplete);
    }
  }, {
    key: "handleResizeSave",
    value: function handleResizeSave(file, newWidth) {
      var _this$props3 = this.props,
          dispatchUploadResizedImage = _this$props3.dispatchUploadResizedImage,
          uploadedFileAccess = _this$props3.uploadedFileAccess,
          onSaveComplete = _this$props3.onSaveComplete;
      dispatchUploadResizedImage(file, newWidth, uploadedFileAccess, onSaveComplete);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          file = _this$props4.file,
          children = _this$props4.children,
          selectedImgFrom = _this$props4.selectedImgFrom,
          dispatchSelectImageToEdit = _this$props4.dispatchSelectImageToEdit,
          dispatchDeselectImageToEdit = _this$props4.dispatchDeselectImageToEdit,
          openedFrom = _this$props4.openedFrom,
          size = _this$props4.size,
          use = _this$props4.use,
          isReadOnly = _this$props4.isReadOnly;

      if ((0, _file.isAnimation)(file)) {
        return null;
      }

      if (selectedImgFrom === _Constants.ImageEditorLocations.SOCIAL_PREVIEW) {
        return _react.default.createElement(_ImageEditor.default, {
          onClose: function onClose() {
            return dispatchDeselectImageToEdit();
          },
          onCropSave: this.handleCropSave,
          onResizeSave: this.handleResizeSave
        });
      }

      return _react.default.createElement(_ScopedFeatureTooltip.default, null, _react.default.createElement(_UIButton.default, {
        onClick: function onClick() {
          return dispatchSelectImageToEdit(file, openedFrom);
        },
        size: size,
        use: use,
        disabled: isReadOnly,
        "data-test-id": "edit-button"
      }, children || _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerCore.actions.cloneAndEdit"
      })));
    }
  }]);
  return EditButton;
}(_react.Component);

EditButton.displayName = 'EditButton';
EditButton.propTypes = {
  children: _propTypes.default.node,
  dispatchSelectImageToEdit: _propTypes.default.func.isRequired,
  dispatchDeselectImageToEdit: _propTypes.default.func.isRequired,
  dispatchUploadResizedImage: _propTypes.default.func.isRequired,
  dispatchUploadEditedImage: _propTypes.default.func.isRequired,
  file: _propTypes.default.instanceOf(_immutable.default.Map),
  onSave: _propTypes.default.func.isRequired,
  onSaveComplete: _propTypes.default.func,
  openedFrom: _propTypes.default.string,
  selectedImgFrom: _propTypes.default.string.isRequired,
  size: _UIButton.default.propTypes.size,
  use: _UIButton.default.propTypes.use,
  isReadOnly: _propTypes.default.bool.isRequired,
  uploadedFileAccess: _propTypes.default.oneOf(Object.keys(_FileAccess.DrawerFileAccess))
};
EditButton.defaultProps = {
  openedFrom: _Constants.ImageEditorLocations.SOCIAL_PREVIEW,
  use: 'tertiary-light',
  size: 'xs'
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSave: function onSave(file, newFile, newUrl, uploadedFileAccess) {
      var fileId = file ? file.get('id') : null;
      return dispatch((0, _Files.saveEdit)(fileId, newFile, newUrl, uploadedFileAccess));
    },
    dispatchUploadEditedImage: function dispatchUploadEditedImage(file, fileName, folderId, uploadedFileAccess, onSaveComplete) {
      return dispatch((0, _Files.uploadEditedImage)(file, fileName, folderId, uploadedFileAccess, onSaveComplete));
    },
    dispatchUploadResizedImage: function dispatchUploadResizedImage(fileId, newWidth, uploadedFileAccess) {
      return dispatch((0, _Files.uploadResizedImage)(fileId, newWidth, uploadedFileAccess));
    },
    dispatchSelectImageToEdit: function dispatchSelectImageToEdit(file, selectedFrom) {
      return dispatch((0, _Files.getSelectImageToEditAction)(file, selectedFrom));
    },
    dispatchDeselectImageToEdit: function dispatchDeselectImageToEdit() {
      return dispatch((0, _Files.getDeselectImageToEditAction)());
    }
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedImgFrom: (0, _EditAndCreateImage.getSelectedImageFrom)(state),
    isReadOnly: (0, _Permissions.getIsReadOnly)(state),
    uploadedFileAccess: (0, _Configuration.getUploadedFileAccess)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EditButton);

exports.default = _default;
module.exports = exports.default;